// @flow

import _ from 'lodash';
import { RequestResult } from '../api';
import type { DataResponse, StatusResponse } from '../api/request-result';

const takeErrorMessage = <T>(res: DataResponse<T>): string => _.get(res, 'Error');
const maybeResponseError = <T>(res: DataResponse<T>): ?Error => res.Error ? new Error(takeErrorMessage(res)) : null;
const createRequestResult = <T>(res: DataResponse<T>): RequestResult => new RequestResult(
	res,
	maybeResponseError(res),
);
const createRequestStatus = ({response: {responseJSON: {Status, StatusText}}}): StatusResponse => ({
	Status: Status,
	StatusText: StatusText,
});

const transformToRequestData =  <T>(res: DataResponse<T>): T => createRequestResult(res || {}).data;
const transformToRequestItems = <T>(res: DataResponse<T>): T[] => createRequestResult(res || {}).items;
const transformToRequestStatus = (res: any): StatusResponse => createRequestStatus(res || {});


const normalizeResponseDataItems = <T>(res: DataResponse<T>, normalizer: Function) => ({
	...res,
	Data: (_.get(res, 'Data') || []).map(normalizer),
});

const normalizeResponseItemsWithTotal = <T>(res: DataResponse<T>, normalizer: Function) => ({
	...res,
	Data: {
		items: (_.get(res, 'Data.Items') || []).map(normalizer),
		total: _.get(res, 'Data.Total') || 0,
	},
});


export {
	transformToRequestData,
	transformToRequestItems,
	transformToRequestStatus,
	normalizeResponseDataItems,
	normalizeResponseItemsWithTotal,
};
